<div class="cover" #cover></div>
<div #innerMenu class="menu-inner">
  <ng-content></ng-content>
</div>